<template>
	<div style="overflow: hidden">
		<transition name="page-change" mode="out-in">
			<slot />
		</transition>
	</div>
</template>

<script>
// import "animate.css";
// leave-active-class="animate__animated animate__fadeOutRight"
export default {
	name: "YwContainer",
};
</script>

<style lang="less" scoped>
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.page-change-enter-active {
	transition: all 0.3s cubic-bezier(0, 0, 0.15, 1);
}
.page-change-leave-active {
	transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.page-change-enter, .page-change-leave-to
/* .page-change-leave-active for below version 2.1.8 */ {
	transform: translateX(20px);
	opacity: 0;
}
</style>
